module.exports = __webpack_public_path__ + "img/vegetable-eggplant-190x100.4e120d3e.jpg";